"use client";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { useState } from "react";
import { useJsApiLoader } from "@react-google-maps/api";
import PlacesAutocomplete from "react-places-autocomplete";
import { featureService } from "services/FeatureService";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const CommuteFilterPlaces = ({commuteFilters, handleLocationSelect, handleChange}) => {

  const [libraries] = useState(["places"]);
  const { isLoaded } = useJsApiLoader({
        id: "google-map-script",
        googleMapsApiKey: featureService.mapKey(),
        libraries,
  });

  const { t } = useTranslation();

  return isLoaded ? (
    <div className="filter">
            <div className="element text form-group">
              <Form.Label>{t("from")}</Form.Label>
              <div className="field">
                <PlacesAutocomplete
                  value={commuteFilters?.commuteSearchTerm?.name|| ""}
                  debounce={500}
                  onChange={(address) => handleChange({ key: "commuteSearchTerm", name: address, id: null })}                
                  onError={(e) => console.log(e)}
                  clearItemsOnError={true}
                  onSelect={handleLocationSelect}
                >
                  {({
                    getInputProps,
                    suggestions,
                    getSuggestionItemProps,
                    loading,
                  }) => (
                    <div className="autocomplete-location">
                      <input
                        {...getInputProps({
                          placeholder: t("location") + "...",
                          className: `location-search-input`,
                        })}
                      />
                      <div className="autocomplete-dropdown-container">
                        {loading && <div>{t("loading")}...</div>}
                        {suggestions.map((suggestion, index) => {
                          const className = suggestion.active
                            ? "suggestion-item--active"
                            : "suggestion-item";

                          return (
                            <div
                              key={index}
                              {...getSuggestionItemProps(suggestion, {
                                className,
                              })}
                            >
                              <span>{suggestion.description}</span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </PlacesAutocomplete>
              </div>
            </div>
          </div>
  ) : (
    <></>
  );
};

export default CommuteFilterPlaces;
